import React, { memo } from 'react'

function calcIndividualPercentages(...values) {
	const max = Math.max(...values)

	if (max > 0) return values.map((v) => `${(100.0 * v) / max}%`)
	else return values.map(() => '0%')
}

// player1Bonus/player2Bonus: optional total including a bonus, rendered in parentheses next to the number
// and as a striped segment after the fill. Bars scale to the highest total, bonus included.
const BarIndividual = memo(({ name, icon, player1, player2, player1Bonus, player2Bonus, leftColor, rightColor }) => {
	const [factor1, factor2, bonusFactor1, bonusFactor2] = calcIndividualPercentages(
		player1,
		player2,
		Math.max(0, (player1Bonus ?? player1) - player1),
		Math.max(0, (player2Bonus ?? player2) - player2),
		player1Bonus ?? 0,
		player2Bonus ?? 0,
	)
	const leftState = player1 >= player2 ? 'winner' : 'loser'
	const rightState = player2 >= player1 ? 'winner' : 'loser'
	const leftBonus = player1Bonus != null ? ' barIndividual__player--bonus' : ''
	const rightBonus = player2Bonus != null ? ' barIndividual__player--bonus' : ''

	return (
		<div className={`barIndividual barIndividual--${name.toLowerCase().replace(/\s+/g, '-')}`}>
			<div className="barIndividual__label">
				{icon && <img className="barIndividual__icon" src={icon} alt="" />}
				{name}
			</div>
			<div className={`barIndividual__player barIndividual__leftPlayer barIndividual__player--${leftState}${leftBonus}`}>
				<div className="barIndividual__number">
					{parseInt(player1).toLocaleString()}
					{player1Bonus != null && <span className="barIndividual__bonus"> ({parseInt(player1Bonus).toLocaleString()})</span>}
				</div>
				<div className="barIndividual__bar">
					<div className="barIndividual__fill" style={{ '--fill': factor1, backgroundColor: leftColor }} />
					{player1Bonus != null && <div className="barIndividual__fill barIndividual__fill--bonus" style={{ '--fill': bonusFactor1, '--bonus-color': leftColor }} />}
				</div>
			</div>
			<div className={`barIndividual__player barIndividual__rightPlayer barIndividual__player--${rightState}${rightBonus}`}>
				<div className="barIndividual__number">
					{parseInt(player2).toLocaleString()}
					{player2Bonus != null && <span className="barIndividual__bonus"> ({parseInt(player2Bonus).toLocaleString()})</span>}
				</div>
				<div className="barIndividual__bar">
					<div className="barIndividual__fill" style={{ '--fill': factor2, backgroundColor: rightColor }} />
					{player2Bonus != null && <div className="barIndividual__fill barIndividual__fill--bonus" style={{ '--fill': bonusFactor2, '--bonus-color': rightColor }} />}
				</div>
			</div>
		</div>
	)
})

export { BarIndividual }
